import { Radio, Text } from '@intellecteu/common-ui';
import { ParticipantDto, RemoteParticipantDto } from 'data';
import { authConfig } from 'data/auth/keycloak/config';
import { Field } from '../ui';

import s from './styles.module.scss';

type SelectAuthProviderProps = {
  provider: ParticipantDto.authProvider | RemoteParticipantDto.authProvider;
};

export const SelectAuthProvider = ({ provider }: SelectAuthProviderProps) => (
  <div className={s.containerFields}>
    <Text component="p" className={s.containerFieldsTitle}>
      Authentication Provider
    </Text>

    <div className={s.containerFieldsItems}>
      <Field
        component={Radio}
        name="authProvider"
        label="Keycloak"
        valueAdapter={() => ParticipantDto.authProvider.KEYCLOAK}
        checked={provider === ParticipantDto.authProvider.KEYCLOAK}
        disabled={!authConfig.authKeycloakEnabled}
      />

      <Field
        component={Radio}
        name="authProvider"
        label="Auth0"
        valueAdapter={() => ParticipantDto.authProvider.AUTH0}
        checked={provider === ParticipantDto.authProvider.AUTH0}
        disabled={!authConfig.authKeycloakEnabled}
      />

      <Field
        component={Radio}
        name="authProvider"
        label="Custom"
        valueAdapter={() => ParticipantDto.authProvider.CUSTOM}
        checked={provider === ParticipantDto.authProvider.CUSTOM}
      />
    </div>
  </div>
);
